import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import Universe from '../models/KB Layer/universe';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class KblayerService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getUniverses(): Observable<{ universes: Universe[] }> {
    return this.http.get<{ universes: Universe[] }>(this.apiUrl + '/kb/universes');
  }
  createUniverse(universeData: Universe): Observable<Universe> {
    return this.http.post<Universe>(this.apiUrl + '/kb/universes', universeData);
  }
  getUniverseById(id: string): Observable<Universe> {
    return this.http.get<Universe>(`${this.apiUrl}/kb/universes/${id}`);
  }
  updateUniverse(id: string, universeData: Universe): Observable<Universe> {
    return this.http.put<Universe>(`${this.apiUrl}/kb/universes/${id}`, universeData);
  }
  deleteUniverse(id: string): Observable<{ universes: Universe[] } | Universe[]> {
    return this.http.delete<{ universes: Universe[] } | Universe[]>(`${this.apiUrl}/kb/universes/${id}`);
  }
}
